export default "/_next/static/images/andrew-breksa-7a4d481a320f24f35ca4af0d470a36e7.png";